import { ApiConstants } from '@epi-constants/actions';

export const checkIfCompanyExists = (company, callback) => ({
  type: `${ApiConstants.CHECK_IF_COMPANY_EXISTS}_REQUEST`,
  company,
  callback
});
